<template>
  <div class="home-game bg-ui-panel grey100--text d-flex">
    <div class="game-card-layout d-flex">
      <div class="coin-ctn">
        <CoinflipCoin
          :size="124"
          :coin="coin"
        />
      </div>

      <div class="align-self-end pa-4">
        <div class="game-info mb-1">
          <h3 class="text-uppercase grey100--text text-body-1 font-weight-bold">
            Coinflip Duels
          </h3>
          <p class="text--secondary text-body-2">
            1v1 with Rust items
          </p>
        </div>


        <h5 class="game-stats text-body-2 text--secondary d-flex align-center">
          {{ games }} games
          <span class="mx-2">&middot;</span>
          <span class="font-weight-bold">${{ bet | toScrap }}</span>
        </h5>
      </div>
    </div>

    <div v-if="xpBonus > 1" class="xp-bonus px-2 py-2 font-weight-bold lh-1 text-caption green700 green200--text">
      +{{ (xpBonus - 1) * 100 | toLocale }}% XP
    </div>
  </div>
</template>

<script>
import CoinflipCoin from '@/modals/games/coinflip/coinflip-game/components/CoinflipCoin'
import { COIN_PICKLES_SALTWATER } from '@/views/games/Coinflip/utils'

export default {
  components: {
    CoinflipCoin,
  },
  props: {
    stats: {
      type: Object,
      default: null,
    },
    conga: {
      type: Object,
      default: null,
    },
  },
  computed: {
    games() {
      return this.stats?.games ?? 0
    },
    bet() {
      return this.stats?.total ?? 0
    },
    xpBonus() {
      return this.conga?.games.coinflip.xpMultiplier ?? 1
    },
    coin() {
      return COIN_PICKLES_SALTWATER
    },
  },
}
</script>

<style lang="scss" scoped>
.home-game {
  position: relative;
  height: 180px;
  cursor: pointer;
  transition: transform 0.3s ease;

  .game-card-layout {
    overflow: hidden;

    @include overlay;
  }

  .coin-ctn {
    position: absolute;
    z-index: 1;
    top: 16px;
    right: 24px;
    transition: transform 0.5s ease;

    .coinflip-coin {
      transform: rotateX(40deg);
    }
  }

  .game-info,
  .game-stats {
    position: relative;
    z-index: 2;
    transition: transform 0.6s ease;
  }

  .game-info {
    text-shadow: 0 0 5px black;
  }

  .xp-bonus {
    position: absolute;
    z-index: 3;
    top: 0;
    right: 0;
    background: gold;
    transform: translate(20%, -50%) rotate(-3deg);
  }

  &:hover {
    transform: translateY(-3px);

    .coin-ctn {
      transform: translateX(-20%) scale(1.2);

      .coinflip-coin {
        animation: spin 2s infinite;
      }
    }

    .game-info {
      transform: translate(16px, -20%) rotate(2deg) scale(1.1);
    }

    .game-stats {
      transform: translate(16px, -10%) rotate(2deg) scale(1.1);
    }
  }
}

@keyframes spin {
  from {
    transform: rotateX(30deg);
  }

  to {
    transform: rotateX(390deg);
  }
}
</style>
